<top-navig [display]="true" [displayLogo]="false" title="CGV"></top-navig>
<div class="cgv" [class.p-95]="ourApp">
    <div class="container">
        <div class="row">
            <div class="col-md-12">
                <h1 class="text-center">CGV à la fois</h1>
                <h4 class="heading">ARTICLE 1 – OBJET ET DÉFINITIONS</h4>
                <hr class="half_space">
                <p>
                    Les présentes Conditions Générales de Vente organisent le service de vente en ligne des produits
                    disponibles
                    dans
                    l’établissement de restauration {{restaurant}} participants et accessibles via le site {{website}}.
                </p>
                <p>
                    Les présentes Conditions Générales de Vente (les "CGV") s'appliquent à toute vente (ci-après "la
                    Vente")
                    d'un ou
                    plusieurs produits (les "Produits") conclue par le Client (le "Client") sur le site marchand {{website}}.
                    (Le "Site") avec l’établissement de restauration {{restaurant}} participant (le "Vendeur").
                </p>
                <p>Les présentes CGV prévaudront sur toutes autres conditions générales ou particulières non
                    expressément
                    agrées
                    par
                    le
                    Vendeur.</p>
                <p>Dans le cadre des présentes conditions générales de vente,</p>
                <ul>
                    <li>
                        Le "Vendeur" désigne la personne physique ou morale exploitant l’établissement de restauration {{restaurant}} et auquel sera adressée la commande du Client. Les coordonnées de cette personne
                        seront
                        précisées au
                        Client sur le courrier électronique de confirmation de commande et sur le ticket de caisse remis
                        par
                        le
                        Vendeur
                        au moment du retrait ou de la livraison des Produits.
                    </li>
                    <li>
                        Le terme "Vente" désigne le service de commande en ligne de Produits disponibles dans
                        l’établissement de
                        restauration participant et accessibles via le site {{website}} Le Client retire sa
                        commande
                        auprès
                        de l’établissement de restauration qui lui sera indiqué ou en obtiendra la livraison au lieu
                        désigné
                        et
                        effectuera le règlement de la commande.
                    </li>
                </ul>
                <h4 class="heading">ARTICLE 2 – PRODUITS</h4>
                <hr class="half_space">
                <p>Les Produits proposés sont ceux qui figurent sur le Site au jour de la Vente, dans la limite des
                    stocks disponibles.
                    Ces Produits sont susceptibles d'être modifiés ou supprimés sans aucun préavis. Les photographies et
                    illustrations
                    présentées sur le Site ne sont pas contractuelles.
                    Les produits vendus doivent être consommés rapidement à compter de leur retrait en magasin ou de
                    leur livraison et
                    ne doivent pas être congelés.</p>

                <h4 class="heading">ARTICLE 3 – PRIX</h4>
                <hr class="half_space">
                <p>Le Vendeur se réserve le droit de modifier ses prix à tout moment, étant entendu que le prix figurant
                    sur le site au
                    jour de la vente sera le seul applicable.
                    Les prix figurants sur le Site sont des prix TTC (toutes taxes comprises), en euros, en tenant
                    compte de la TVA
                    applicable au jour de la Vente.</p>

                <h4 class="heading">ARTICLE 4 – CRÉATION D’UN COMPTE</h4>
                <hr class="half_space">
                <p>Pour conclure une Vente, le Client crée un compte personnel qui recense l'historique des Ventes au
                    Client.
                    Lors de la création du Compte, le Client choisit un identifiant et un mot de passe associés à une
                    adresse
                    électronique valide.</p>

                <p>Certaines données obligatoires sont demandées au client, notamment : son nom, prénom, adresse postale
                    (en cas de
                    livraison), adresse électronique et numéro de téléphone portable.</p>

                <p>L’identifiant et le mot de passe restent personnels au Client et le Vendeur ne saurait être tenu
                    responsable de toute
                    utilisation frauduleuse du compte du Client par un tiers.</p>

                <p>>En cas d'oubli du mot de passe, le Client pourra solliciter un courrier électronique de rappel à
                    l'adresse électronique
                    indiquée.</p>

                <p>Il appartient au Client de garder ses informations strictement confidentielles et de ne pas les
                    communiquer à des
                    tiers, afin d’éviter autant que possible tout risque d’intrusion de son compte Client et la
                    passation de Commandes à
                    son insu par des personnes non autorisées. Le Vendeur ne saurait être tenu responsable de toute
                    utilisation du
                    compte Client par un tiers qui aurait eu accès à son identifiant et à son mot de passe de quelque
                    manière que ce
                    soit.</p>

                <h4 class="heading">ARTICLE 5 – CONCLUSION DES VENTES</h4>
                <hr class="half_space">
                <p>La Vente conclue par le Client se déroule comme suit :</p>

                <ol>
                    <li>Connexion au site {{website}}</li>
                    <li>Remplissage du panier et validation</li>
                    <li>Création du compte personnel ou connexion à ce compte</li>
                    <li>Choix du mode de retrait des marchandises</li>
                    <li>Vérification de la Commande</li>
                    <li>Envoi de la commande et confirmation</li>
                    <li>Envoi d’un courrier électronique confirmation comportant les références de la Vente.</li>
                    <li>Retrait des Produits auprès de l’établissement de restauration aux heures d’ouverture qui
                        lui seront
                        indiquées au moment de la commande et ou Livraison à l’adresse précisée par le Client.</li>
                </ol>



                <h4 class="heading">ARTICLE 6 – LIVRAISON</h4>
                <hr class="half_space">
                <p>Le CLIENT a la possibilité de passer commande à toute heure. Les livraisons seront assurées
                    pendant les heures
                    d’ouverture du magasin et au plus tôt 45 minutes après son ouverture.
                    Un délai de livraison est indiqué au CLIENT lors de la confirmation de la commande. Ce délai est
                    communiqué à
                    titre informatif. Il n’a pas de valeur contractuelle. Son non-respect n’engage pas la
                    responsabilité de
                    l’établissement de restauration concerné.</p>

                <p>La livraison se fait au domicile du CLIENT, tel qu’il a été mentionné lors de la passation de
                    commande. En cas
                    d’erreur dans le libellé des coordonnées du CLIENT, l’établissement de restauration concerné ne
                    saurait être
                    tenu responsable de l’impossibilité dans laquelle il se trouve de livrer la commande.</p>

                <p>Le CLIENT a la possibilité de retirer sa commande directement à l’établissement de restauration
                    concerné. Les
                    coordonnées du magasin sont disponible sur le site de l’établissement de restauration.
                    TRÈS IMPORTANT :</p>

                <p>Tout retrait ou toute livraison ne pourra être effectué qu’après présentation des références de la
                    commande indiquées
                    sur le courrier électronique et après paiement du prix. L’établissement de restauration remettra
                    alors un ticket de
                    caisse au Client.</p>

                <h4 class="heading">ARTICLE 7 – ARCHIVAGE</h4>
                <hr class="half_space">

                <p>Le Vendeur procèdera à l'archivage des ventes et des factures sur un support fiable et durable,
                    constituant une copie
                    fidèle conformément aux dispositions de l'article 1348 du Code Civil.</p>

                <h4 class="heading">ARTICLE 8 – ANNULATION ET MODIFICATION</h4>
                <hr class="half_space">
                <p>Toute commande qui a été validée, payée et retirée
                    ne peut être annulée.</p>

                <p>Aucune marchandise ne sera reprise ou échangée.</p>

                <p>Toute commande passée sur le Site est ferme et définitive et ne peut être annulée ou
                    modifiée.</p>

                <p>Conformément à l'article L. 121-20-2 3° du Code de la Consommation, le droit de rétractation
                    applicable en matière de
                    vente à distance est exclu dans l’hypothèse de la fourniture de biens qui du fait de leur
                    nature
                    sont susceptibles
                    de se détériorer ou de se périmer rapidement.</p>

                <h4 class="heading">ARTICLE 9 – RECLAMATION</h4>
                <hr class="half_space">
                <p>Toute réclamation concernant la Vente sera adressée auprès du Vendeur dans un délai maximum
                    de
                    quarante-huit (48)
                    heures après le retrait ou la livraison des Produits, par courrier recommandé avec accusé de
                    réception, à l'adresse
                    de l’établissement de restauration figurant sur le ticket de caisse. A l’expiration du
                    délai, aucune
                    réclamation ne
                    pourra être prise en compte.</p>

                <p>Toute réclamation sur le fonctionnement du Site sera adressée par courrier recommandé avec
                    accusé de
                    réception à
                    l'adresse suivante :{{address}} </p>

                <h4 class="heading">ARTICLE 10 – EXCLUSION DE RESPONSABILITÉ</h4>
                <hr class="half_space">
                <p>Le Vendeur n’est tenu que d’une obligation de moyen dans le processus de vente en ligne.</p>

                <p>Le Vendeur n’est pas responsable des risques relatifs à l'utilisation du réseau Internet
                    (perte de
                    données,
                    intrusion, virus...).</p>

                <h4 class="heading">ARTICLE 11 - PROTECTION DES DONNÉES PERSONNELLES</h4>
                <hr class="half_space">
                <p>Via le site de commande en ligne, le Vendeur collecte les données personnelles, telles que
                    les noms
                    et prénoms,
                    adresses postales et électroniques, numéro de téléphone portable, soumises par le Client à
                    des fins
                    commerciales et
                    notamment pour le faire participer à des opérations promotionnelles ou de publicité.</p>

                <p>Le Vendeur partage ces données personnelles uniquement sur le territoire français avec les
                    différentes structures
                    ayant des liens capitalistiques ou contractuels avec lui.</p>

                <p>Le Vendeur peut solliciter des entreprises prestataires pour exécuter des tâches diverses,
                    notamment
                    des tâches à
                    caractère commercial telles l'exécution de commandes, l'assistance en matière de campagne
                    promotionnelle, la
                    fourniture de services techniques pour les sites web, etc. Ces entreprises prestataires ont
                    accès
                    aux données
                    personnelles si cela est nécessaire à l'accomplissement de leurs prestations et ne peuvent
                    utiliser
                    ces données en
                    dehors de l’exécution de ces prestations. Ces entreprises s’engagent à respecter la
                    législation sur
                    la collecte et
                    le traitement des données à caractère personnel.</p>

                <p>Le Vendeur ne vend, ne cède et ne communique aucune donnée personnelle à des tiers.</p>

                <p>Dans l’hypothèse où le Vendeur serait contraint, afin de respecter une décision
                    administrative,
                    légale ou judiciaire,
                    de communiquer à un tiers autorisé, au sens de la loi du 6 janvier 1978 relative à
                    l'informatique,
                    aux fichiers et
                    aux libertés, des informations relatives aux données personnelles fichées et traitées
                    qu'elle
                    détiendrait, il
                    s'engage, préalablement à toute communication, à en informer les personnes concernées.</p>

                <p>Conformément à la loi « informatique et libertés » du 6 janvier 1978, le Client bénéficie
                    d’un droit
                    d’accès et de
                    rectification aux informations qui le concernent. Si le client souhaite exercer ce droit,
                    obtenir
                    communication des
                    informations le concernant ou encore s’opposer au traitement de ses données personnelles, il
                    s’adresse au : {{address}}. </p>

                <h4 class="heading">ARTICLE 12 – INDIVISIBILITÉ</h4>
                <hr class="half_space">
                <p>La nullité d’une des clauses du présent contrat en application notamment d’une loi, d’un
                    règlement ou
                    à la suite
                    d’une décision de justice n’entraînera pas la nullité des présentes CGV.</p>

                <h4 class="heading">ARTICLE 13 – LOI APPLICABLE</h4>
                <hr class="half_space">
                <p>Les présentes CGV sont soumises aux lois de la République Française.</p>

                <h4 class="heading">ARTICLE 14 – JURIDICTION COMPÉTENTE</h4>
                <hr class="half_space">
                <p>En cas de litige, Le Tribunal compétent est désigné par les règles de droit commun.</p>
            </div>
        </div>
    </div>
</div>